import React, { Component } from 'react';


class Funds extends Component{
    render(){
        return(
            <div className="center">Funds</div>
        )
    }
}


export default Funds